import styled from '@emotion/styled'

export const InputFieldControl = styled.input<{ $invalid?: boolean }>`
  width: 100%;
  height: 48px;
  padding: 0 14px;
  border: 2px solid ${({ $invalid }) => ($invalid ? '#e53935' : '#596170')};
  border-radius: 6px;
  outline: none;
  color: #202327;
  background: #fff;
  box-sizing: border-box;
  font-family: inherit;
  font-size: 16px;
  line-height: 1;

  &:hover:not(:disabled) {
    border-color: #7d8798;
  }

  &:focus {
    border-color: #ff8e00;
    box-shadow: 0 0 0 3px rgba(255, 142, 0, 0.2);
  }

  &:disabled {
    color: #717782;
    background: #d9dce1;
    cursor: not-allowed;
  }

  &::placeholder {
    color: #717782;
  }
`
